import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MaintenanceConcessionaireComponent } from "./maintenance-concessionaire.component";
import { CreateEditConcessionaireComponent } from "./create-edit-concessionaire/create-edit-concessionaire.component";
import { ListConcessionaireComponent } from "./list-concessionaire/list-concessionaire.component";
import { LoginGuard } from "../core/guards/login.guard";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";

const routesConcessionaire: Routes = [
  {
    path: "",
    component: MaintenanceConcessionaireComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "lista",
        component: ListConcessionaireComponent,
      },
      {
        path: "creacion",
        component: CreateEditConcessionaireComponent,
        data: {
          operation: "creacion",
        },
      },
      {
        path: "edicion/:id",
        component: CreateEditConcessionaireComponent,
        data: {
          operation: "edicion",
        },
      },
      {
        path: "datos-concesionario",
        component: CreateEditConcessionaireComponent,
        data: {
          operation: "edicion",
          routing: "/",
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesConcessionaire)],
  exports: [RouterModule],
})
export class ConcessionaireRoutingModule {}
